import { render, staticRenderFns } from "./SupplyList.vue?vue&type=template&id=3dd26f52&"
import script from "./SupplyList.vue?vue&type=script&lang=js&"
export * from "./SupplyList.vue?vue&type=script&lang=js&"
import style0 from "./SupplyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports